/**
 * How many NEW graphemes a free learner may introduce to their deck per local calendar day.
 *
 * Counted per grapheme, not per card: introducing a character enrolls its meaning card plus a
 * pronunciation card per introduced reading, and that bundle is ONE new grapheme. A grapheme counts
 * once its meaning card starts studying (`user_card.started_studying_at`) on the current local day,
 * whichever path enrolled it — a lesson, a manual "Learn", or the learn queue.
 */
export const FREE_TIER_DAILY_NEW_GRAPHEME_LIMIT = 20;
